/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UINotificationMessageParameterDataTypeEnum = 'STRING' | 'DATE' | 'DATE-TIME' | 'NUMBER' | 'INTEGER';

export const UINotificationMessageParameterDataTypeEnum = {

    STRING: 'STRING' as UINotificationMessageParameterDataTypeEnum,

    DATE: 'DATE' as UINotificationMessageParameterDataTypeEnum,

    DATE_TIME: 'DATE-TIME' as UINotificationMessageParameterDataTypeEnum,

    NUMBER: 'NUMBER' as UINotificationMessageParameterDataTypeEnum,

    INTEGER: 'INTEGER' as UINotificationMessageParameterDataTypeEnum
};

